import { useContext } from 'react';
import { MyContext } from '../Store';
import { trans, getViewName } from '../utils';

import { OrderForm } from './OrderForm';

export const Footer = () => {
  const [state] = useContext(MyContext);
  const { productData, selectedView } = state;

  return (
    <footer className="footer">
      <div>
        {trans('Widok')}: <i>{getViewName(selectedView)}</i>, {trans('Rozmiar')}: <i>{productData.size}</i>
      </div>
      <div>
        <OrderForm />
      </div>
    </footer>
  );
};
